import React from 'react';
import PropTypes from 'prop-types';
import { containsLocationSpecific } from '../modules/filtering';
import { AVAILABLE_IN, REGIONS } from '../modules/constants';

/**
 * Determines if the subsection field is empty and is not the same as the previous subsection.
 *
 * @param {string} currentSubsection the current menu items subsection
 * @param {string} previousSubsection the previous menu items subsection
 * @returns {boolean} true if current subsection is not the same as the last subsection
 */
function compareSection(currentSubsection, previousSubsection) {
    return currentSubsection && currentSubsection !== previousSubsection;
}

/**
 * Determines whether the current item should be placed under the same subsection as the previous item or not.
 *
 * @param {?string} itemSubSection the current menu items subsection
 * @param {?string} lastSubSection the previous menu items subsection
 * @param {?string} restaurantGroup the current menu items restaurant group
 * @param {?string} lastRestaurantGroup the previous menu items restaurant group
 * @returns {HTMLHeadingElement} the heading for a subsection or null if empty
 */
function SubSection({
    itemSubSection,
    lastSubSection,
    restaurantGroup,
    lastRestaurantGroup
}) {
    if (
        compareSection(restaurantGroup, lastRestaurantGroup) &&
        containsLocationSpecific(restaurantGroup)
    ) {
        const restaurant =
            REGIONS[
                Object.keys(REGIONS).find(
                    (region) =>
                        region.toLowerCase() === restaurantGroup.toLowerCase()
                )
            ];

        return (
            <h3 className='subSection'>{`${AVAILABLE_IN} ${restaurant}`}</h3>
        );
    }
    if (compareSection(itemSubSection, lastSubSection)) {
        const formattedSubsection = itemSubSection
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
            .replace(/ or | OR | Or /g, ' OR ');

        return <h3 className='subSection'>{formattedSubsection}</h3>;
    }

    return null;
}

SubSection.propTypes = {
    itemSubSection: PropTypes.string,
    lastSubSection: PropTypes.string,
    restaurantGroup: PropTypes.string,
    lastRestaurantGroup: PropTypes.string
};

export { SubSection };
